// Logic shared by the staff review and PDF views (identical in both).
export default {
  methods: {
    duplicateItem() {
      this.itemsss.push(Date.now());
    },
    onComplete() {
      if (
        this.form.personal.checkListOffice1 === true &&
        this.form.personal.checkListOffice2 === true &&
        this.form.personal.checkListOffice3 === true &&
        this.form.personal.checkListOffice4 === true &&
        this.form.personal.checkListOffice5 === true &&
        this.form.personal.checkListOffice6 === true
      ) {
        window.location.href = "/application_list";
      } else {
        window.location.href = "/application_list";
      }
    },
  },
};
